import { Injectable } from "@angular/core";
import { CoreLogService } from "../services/log.service";
import { CoreCOMService } from "../services/com.service";
import { ClientType } from "../services/com/comEnvironmentClient";

@Injectable({
  providedIn: "root"
})
export class StatusBarProvider {

  constructor(private _coreLogService: CoreLogService,
    private _coreCOMService: CoreCOMService) {
  }

  /**set the color of text in statusBar */
  public SetStausBarTextStyle(): Promise<void> {
    const me = this;
    return new Promise((resolve, reject) => {
      if (me._coreCOMService.environment.client.isMobile) {
        me._coreCOMService.environment.statusBar.setStatusBarTextstyle()
          .then(() => {
            resolve();
          })
          .catch(e => {
            me._coreLogService.error("StatusBarProvider", "SetStausBarTextStyle", e);
          });
        } else {
        resolve();
      }
    });
  }

  // set the background of statusBar
  public SetStausBarBackgroundStyle(): Promise<void> {
    const me = this;
    return new Promise((resolve, reject) => {
      if (me._coreCOMService.environment.client.isMobile) {
        if (me._coreCOMService.environment.client.type === ClientType.ios) {
          // for IOS backgroundColorByHexString work when overlaysWebView is false;
          me._coreCOMService.environment.statusBar.overlaysWebView(false);
        }
        const statusBarBackGroundColor = getComputedStyle(document.documentElement).getPropertyValue("--statusbar-background-color").trim();
        me._coreCOMService.environment.statusBar.backgroundColorByHexString(statusBarBackGroundColor)
        .then(() => {
          resolve();
        })
          .catch(e => {
            me._coreLogService.error("StatusBarProvider", "SetStausBarBackgroundStyle", e);
          });
      } else {
        resolve();
      }
    });
  }
}
